import { CRM } from "@/components/atomic-crm/root/CRM";
// GAVION: Gavion navigation (spec 10 §4)
import { GavionLayout } from "@/components/gavion/layout/GavionLayout";
// GAVION: Gavion dashboard replaces the upstream one, incl. the teal deals chart (spec 09 §4)
import { GavionDashboard } from "@/components/gavion/dashboard/GavionDashboard";

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - darkModeLogo / lightModeLogo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * Logos must be an imported asset, an absolute URL, or a data URI — never a
 * route-relative path like "./img/logo.png", which breaks on nested routes.
 *
 * @example
 * import logoDark from "./logo-dark.svg";
 * import logoLight from "./logo-light.svg";
 *
 * const App = () => (
 *    <CRM
 *       darkModeLogo={logoDark}
 *       lightModeLogo={logoLight}
 *       title="Acme CRM"
 *    />
 * );
 */
// GAVION: Gavion layout and dashboard; disableTelemetry stops the upstream marmelab beacons (B7 final M10)
const App = () => (
  <CRM layout={GavionLayout} dashboard={GavionDashboard} disableTelemetry />
);

export default App;
